/* ========================================
   TSG Projector Fit Calculator — Engine
   Top Shelf Golf — Proprietary
   ======================================== */
(function(){
"use strict";

/* ---- Encoded Projector Database ---- */
var _0x=atob("W3siYiI6IkJlblEiLCJtIjoiQUg1MDBTVCIsInRyIjpbMC41LDAuNV0sInIiOiIxMDgwcCIsImwiOjQwMDAsInMiOiJMYXNlciIsImEiOiIxNjo5Iiwic2EiOlsiMTY6OSIsIjE2OjEwIiwiNDozIiwiMToxIl0sInAiOjE5OTksImgiOiJiZW5xLWFoNTAwc3QtNDAwMC1sdW1lbi0xMDgwcC1sYXNlci1zaG9ydC10aHJvdy1nb2xmLXNpbXVsYXRvci1wcm9qZWN0b3IiLCJpIjoiZmlsZXMvQmVuUS1BSDUwMFNULVNob3J0LVRocm93LUdvbGYtU2ltdWxhdG9yLVByb2plY3Rvci5qcGcifSx7ImIiOiJCZW5RIiwibSI6IkFINzAwU1QiLCJ0ciI6WzAuNjksMC44M10sInIiOiIxMDgwcCIsImwiOjQwMDAsInMiOiJMYXNlciIsImEiOiIxNjo5Iiwic2EiOlsiMTY6OSIsIjQ6MyIsIjE6MSJdLCJwIjoyMjk5LCJoIjoiYmVucS1haDcwMHN0LTQwMDAtbHVtZW4tMTA4MHAtbGFzZXItc2hvcnQtdGhyb3ctZ29sZi1zaW11bGF0b3ItcHJvamVjdG9yIiwiaSI6ImZpbGVzL0JlblEtQUg3MDBTVC1TaG9ydC1UaHJvdy1Hb2xmLVNpbXVsYXRvci1Qcm9qZWN0b3JfY2ZmMGE0MTctM2ExMS00NjhiLWFlZTgtNTVhNDg4OGZhNmZlLmpwZyJ9LHsiYiI6IkJlblEiLCJtIjoiQUs3MDBTVCIsInRyIjpbMC42OSwwLjgzXSwiciI6IjRLIiwibCI6NDAwMCwicyI6Ikxhc2VyIiwiYSI6IjE2OjkiLCJzYSI6WyIxNjo5IiwiNDozIiwiMToxIl0sInAiOjI4OTksImgiOiJiZW5xLWFrNzAwc3QtNDAwMC1sdW1lbi00ay1sYXNlci1zaG9ydC10aHJvdy1nb2xmLXNpbXVsYXRvci1wcm9qZWN0b3IiLCJpIjoiZmlsZXMvQmVuUS1BSzcwMFNULVNob3J0LVRocm93LUdvbGYtU2ltdWxhdG9yLVByb2plY3Rvci5qcGcifSx7ImIiOiJCZW5RIiwibSI6IkxLOTM2U1QiLCJ0ciI6WzAuODEsMC44OV0sInIiOiI0SyIsImwiOjUxMDAsInMiOiJMYXNlciIsImEiOiIxNjo5Iiwic2EiOlsiMTY6OSIsIjE2OjEwIiwiNDozIl0sInAiOjQ4OTksImgiOiJiZW5xLWxrOTM2c3QtNTEwMC1sdW1lbi00ay1sYXNlci1zaG9ydC10aHJvdy1nb2xmLXNpbXVsYXRvci1wcm9qZWN0b3IiLCJpIjoiZmlsZXMvQmVuUS1MSzkzNlNULVNob3J0LVRocm93LUdvbGYtU2ltdWxhdG9yLVByb2plY3Rvci1EaWFnb25hbC5qcGcifSx7ImIiOiJPcHRvbWEiLCJtIjoiWlczNTBTVCIsInRyIjpbMC41MjEsMC41MjFdLCJyIjoiV1hHQSIsImwiOjM2MDAsInMiOiJMYXNlciIsImEiOiIxNjoxMCIsInNhIjpbIjE2OjEwIiwiMTY6OSIsIjQ6MyJdLCJwIjo5MDksImgiOiJvcHRvbWEtenczNTBzdC1zaG9ydC10aHJvdy1nb2xmLXNpbXVsYXRvci1wcm9qZWN0b3IiLCJpIjoiZmlsZXMvT3B0b21hLVpXMzUwU1QtR29sZi1TaW11bGF0b3ItUHJvamVjdG9yLmpwZyJ9LHsiYiI6Ik9wdG9tYSIsIm0iOiJHVDIwMDBIRFIiLCJ0ciI6WzAuNDk2LDAuNDk2XSwiciI6IjEwODBwIiwibCI6MzUwMCwicyI6Ikxhc2VyIiwiYSI6IjE2OjkiLCJzYSI6WyIxNjo5IiwiNDozIiwiMTY6MTAiXSwicCI6MTE5OSwiaCI6Im9wdG9tYS1ndDIwMDBoZHItc2hvcnQtdGhyb3ctZ29sZi1zaW11bGF0b3ItcHJvamVjdG9yIiwiaSI6ImZpbGVzL09wdG9tYS1HVDIwMDBIRFItR29sZi1TaW11bGF0b3ItUHJvamVjdG9yLTYwMHg0MjAuanBnIn0seyJiIjoiT3B0b21hIiwibSI6IjRLNDAwU1R4IiwidHIiOlswLjUsMC41XSwiciI6IjRLIiwibCI6NDAwMCwicyI6IkxhbXAiLCJhIjoiMTY6OSIsInNhIjpbIjE2OjkiLCI0OjMiXSwicCI6MjI4OSwiaCI6Im9wdG9tYS00azQwMHN0eC1zaG9ydC10aHJvdy1nb2xmLXNpbXVsYXRvci1wcm9qZWN0b3IiLCJpIjoicHJvZHVjdHMvT3B0b21hLTRLNDAwU1R4LUdvbGYtU2ltdWxhdG9yLVByb2plY3Rvci5qcGcifSx7ImIiOiJCZW5RIiwibSI6IkFXMzBTVCIsInRyIjpbMC43MiwwLjg3XSwiciI6IldYR0EiLCJsIjozMjAwLCJzIjoiTEVEIiwiYSI6IjE2OjEwIiwic2EiOlsiMTY6OSIsIjE2OjEwIiwiNDozIiwiMToxIl0sInAiOjExOTksImgiOiJiZW5xLWF3MzBzdC0zMjAwLWx1bWVuLWxlZC13eGdhLXNob3J0LXRocm93LWdvbGYtc2ltdWxhdG9yLXByb2plY3RvciIsImkiOiJmaWxlcy9CZW5RLUFXMzBTVC1TaG9ydC1UaHJvdy1Hb2xmLVNpbXVsYXRvci1Qcm9qZWN0b3JfODk3MzU0ZjItMTg0Yy00ZmJkLTljOWEtMTdkY2M0NzcyYmMzLmpwZyJ9LHsiYiI6IkJlblEiLCJtIjoiVEg2NzFTVCIsInRyIjpbMC42OSwwLjgzXSwiciI6IjEwODBwIiwibCI6MzAwMCwicyI6IkxhbXAiLCJhIjoiMTY6OSIsInNhIjpbIjE2OjkiLCI0OjMiXSwicCI6OTQ5LCJoIjoiYmVucS10aDY3MXN0LTMwMDAtbHVtZW4tMTA4MHAtc2hvcnQtdGhyb3ctZ29sZi1zaW11bGF0b3ItcHJvamVjdG9yIiwiaSI6ImZpbGVzL0JlblEtVEg2NzFTVC1TaG9ydC1UaHJvdy1Hb2xmLVNpbXVsYXRvci1Qcm9qZWN0b3IuanBnIn0seyJiIjoiQmVuUSIsIm0iOiJUSzcxMFNUaSIsInRyIjpbMC42OSwwLjgzXSwiciI6IjRLIiwibCI6MzIwMCwicyI6Ikxhc2VyIiwiYSI6IjE2OjkiLCJzYSI6WyIxNjo5IiwiNDozIl0sInAiOjIxOTksImgiOiJiZW5xLXRrNzEwc3RpLTMyMDAtbHVtZW4tNGstbGFzZXItc2hvcnQtdGhyb3ctZ29sZi1zaW11bGF0b3ItcHJvamVjdG9yIiwiaSI6ImZpbGVzL0JlblEtVEs3MTBTVGktU2hvcnQtVGhyb3ctR29sZi1TaW11bGF0b3ItUHJvamVjdG9yLmpwZyJ9LHsiYiI6IkJlblEiLCJtIjoiTFU3MTAiLCJ0ciI6WzEuMzYsMi4xOF0sInIiOiJXVVhHQSIsImwiOjQwMDAsInMiOiJMYXNlciIsImEiOiIxNjoxMCIsInNhIjpbIjE2OjEwIiwiMTY6OSIsIjQ6MyJdLCJwIjoxNjk5LCJoIjoiYmVucS1sdTcxMC00MDAwLWx1bWVuLXd1eGdhLWxhc2VyLWdvbGYtc2ltdWxhdG9yLXByb2plY3RvciIsImkiOiJmaWxlcy9CZW5RLUxVNzEwLUdvbGYtU2ltdWxhdG9yLVByb2plY3Rvci5qcGcifSx7ImIiOiJCZW5RIiwibSI6IkxLODMwU1QiLCJ0ciI6WzAuNDk2LDAuNDk2XSwiciI6IjRLIiwibCI6NDAwMCwicyI6Ikxhc2VyIiwiYSI6IjE2OjkiLCJzYSI6WyIxNjo5IiwiNDozIiwiMTY6MTAiLCIxOjEiLCI1OjQiXSwicCI6MjQ5OSwiaCI6ImJlbnEtbGs4MzBzdC00MDAwLWx1bWVuLTRrLWxhc2VyLXNob3J0LXRocm93LWdvbGYtc2ltdWxhdG9yLXByb2plY3RvciIsImkiOiJmaWxlcy9CZW5RLUxLODMwU1QtU2hvcnQtVGhyb3ctR29sZi1TaW11bGF0b3ItUHJvamVjdG9yLmpwZyJ9LHsiYiI6IkJlblEiLCJtIjoiTFU5NjBTVDIiLCJ0ciI6WzAuNSwwLjVdLCJyIjoiV1VYR0EiLCJsIjo1MjAwLCJzIjoiTGFzZXIiLCJhIjoiMTY6MTAiLCJzYSI6WyIxNjoxMCIsIjE2OjkiLCI0OjMiXSwicCI6NzQ5OSwiaCI6ImJlbnEtbHU5NjBzdDItNTIwMC1sdW1lbi13dXhnYS1sYXNlci1zaG9ydC10aHJvdy1nb2xmLXNpbXVsYXRvci1wcm9qZWN0b3IiLCJpIjoiZmlsZXMvQmVuUS1MVTk2MFNUMi1TaG9ydC1UaHJvdy1Hb2xmLVNpbXVsYXRvci1Qcm9qZWN0b3IuanBnIn0seyJiIjoiQmVuUSIsIm0iOiJBSDMwU1QiLCJ0ciI6WzAuNjksMC44M10sInIiOiIxMDgwcCIsImwiOjMwMDAsInMiOiJMRUQiLCJhIjoiMTY6OSIsInNhIjpbIjE2OjkiLCIxNjoxMCIsIjQ6MyIsIjE6MSJdLCJwIjoxNDk5LCJoIjoiYmVucS1haDMwc3QtMzAwMC1sdW1lbi0xMDgwcC1sZWQtc2hvcnQtdGhyb3ctZ29sZi1zaW11bGF0b3ItcHJvamVjdG9yIiwiaSI6ImZpbGVzL0JlblEtQUgzMDBTVC1TaG9ydC1UaHJvdy1Hb2xmLVNpbXVsYXRvci1Qcm9qZWN0b3IuanBnIn0seyJiIjoiT3B0b21hIiwibSI6IlpIMzUwU1QiLCJ0ciI6WzAuNDk2LDAuNDk2XSwiciI6IjEwODBwIiwibCI6MzUwMCwicyI6Ikxhc2VyIiwiYSI6IjE2OjkiLCJzYSI6WyIxNjo5IiwiMTY6MTAiLCI0OjMiXSwicCI6MTQ4OSwiaCI6Im9wdG9tYS16aDM1MHN0LWZ1bGwtaGQtc2hvcnQtdGhyb3ctZ29sZi1zaW11bGF0b3ItcHJvamVjdG9yIiwiaSI6ImZpbGVzL29wdG9tYS16aDM1MHN0LWZ1bGwtaGQtc2hvcnQtdGhyb3ctZ29sZi1zaW11bGF0b3ItcHJvamVjdG9yLXJlYmFsYW5jZWQtMS5qcGcifSx7ImIiOiJPcHRvbWEiLCJtIjoiWlU1MDdUU1QiLCJ0ciI6WzAuNTgsMC41OF0sInIiOiJXVVhHQSIsImwiOjUwMDAsInMiOiJMYXNlciIsImEiOiIxNjoxMCIsInNhIjpbIjE2OjEwIiwiMTY6OSIsIjQ6MyJdLCJwIjozOTk5LCJoIjoib3B0b21hLXp1NTA3dHN0LXd1eGdhLXNob3J0LXRocm93LWdvbGYtc2ltdWxhdG9yLXByb2plY3RvciIsImkiOiJmaWxlcy9PcHRvbWEtWlU1MDdUU1QtR29sZi1TaW11bGF0b3ItUHJvamVjdG9yLmpwZyJ9LHsiYiI6Ik9wdG9tYSIsIm0iOiJVSFozNVNUIiwidHIiOlswLjQ5NiwwLjQ5Nl0sInIiOiI0SyIsImwiOjM1MDAsInMiOiJMYXNlciIsImEiOiIxNjo5Iiwic2EiOlsiMTY6OSIsIjE2OjEwIiwiNDozIl0sInAiOjIxOTksImgiOiJvcHRvbWEtdWh6MzVzdC00ay11aGQtc2hvcnQtdGhyb3ctZ29sZi1zaW11bGF0b3ItcHJvamVjdG9yIiwiaSI6ImZpbGVzL29wdG9tYS11aHozNXN0LTRrLXVoZC1zaG9ydC10aHJvdy1nb2xmLXNpbXVsYXRvci1wcm9qZWN0b3ItcmViYWxhbmNlZC0xLmpwZyJ9LHsiYiI6Ik9wdG9tYSIsIm0iOiJaVTYwN1RTVCIsInRyIjpbMC41OCwwLjU4XSwiciI6IldVWEdBIiwibCI6NjAwMCwicyI6Ikxhc2VyIiwiYSI6IjE2OjEwIiwic2EiOlsiMTY6MTAiLCIxNjo5IiwiNDozIl0sInAiOjQ3OTksImgiOiJvcHRvbWEtenU2MDd0c3Qtd3V4Z2Etc2hvcnQtdGhyb3ctZ29sZi1zaW11bGF0b3ItcHJvamVjdG9yIiwiaSI6ImZpbGVzL09wdG9tYS1aVTYwN1RTVC1Hb2xmLVNpbXVsYXRvci1Qcm9qZWN0b3IuanBnIn0seyJiIjoiT3B0b21hIiwibSI6IlpLNjA4VFNUIiwidHIiOlswLjU4LDAuNThdLCJyIjoiNEsiLCJsIjo2MDAwLCJzIjoiTGFzZXIiLCJhIjoiMTY6OSIsInNhIjpbIjE2OjkiLCI0OjMiXSwicCI6Njg1OSwiaCI6Im9wdG9tYS16azYwOHRzdC00ay11aGQtc2hvcnQtdGhyb3ctZ29sZi1zaW11bGF0b3ItcHJvamVjdG9yIiwiaSI6ImZpbGVzL09wdG9tYS1aSzYwOFRTVC1Hb2xmLVNpbXVsYXRvci1Qcm9qZWN0b3ItVG9wLmpwZyJ9LHsiYiI6Ik9wdG9tYSIsIm0iOiJaVTgyMFRTVCIsInRyIjpbMC43NSwwLjk1XSwiciI6IldVWEdBIiwibCI6ODIwMCwicyI6Ikxhc2VyIiwiYSI6IjE2OjEwIiwic2EiOlsiMTY6MTAiLCIxNjo5IiwiNDozIl0sInAiOjc0OTksImgiOiJvcHRvbWEtenU4MjB0c3Qtd3V4Z2Etc2hvcnQtdGhyb3ctbGFzZXItZ29sZi1zaW11bGF0b3ItcHJvamVjdG9yIiwiaSI6ImZpbGVzL09wdG9tYS1aVTgyMFRTVC1Hb2xmLVNpbXVsYXRvci1Qcm9qZWN0b3IuanBnIn0seyJiIjoiT3B0b21hIiwibSI6IlpVOTIwVFNUIiwidHIiOlswLjY1LDAuNzVdLCJyIjoiV1VYR0EiLCJsIjo5ODAwLCJzIjoiTGFzZXIiLCJhIjoiMTY6MTAiLCJzYSI6WyIxNjoxMCIsIjE2OjkiLCI0OjMiXSwicCI6MTE0MzksImgiOiJvcHRvbWEtenU5MjB0c3Qtd3V4Z2Etc2hvcnQtdGhyb3ctbGFzZXItZ29sZi1zaW11bGF0b3ItcHJvamVjdG9yIiwiaSI6ImZpbGVzL29wdG9tYS16dTkyMHRzdC13dXhnYS1zaG9ydC10aHJvdy1sYXNlci1nb2xmLXNpbXVsYXRvci1wcm9qZWN0b3ItcmViYWxhbmNlZC0xLmpwZyJ9LHsiYiI6Ik9wdG9tYSIsIm0iOiJaSzgxMFRTVCIsInRyIjpbMC42NSwwLjc1XSwiciI6IjRLIiwibCI6ODUwMCwicyI6Ikxhc2VyIiwiYSI6IjE2OjkiLCJzYSI6WyIxNjo5IiwiNDozIiwiMjE6OSJdLCJwIjoxNTQzOSwiaCI6Im9wdG9tYS16azgxMHRzdC00ay11aGQtc2hvcnQtdGhyb3ctbGFzZXItZ29sZi1zaW11bGF0b3ItcHJvamVjdG9yIiwiaSI6ImZpbGVzL29wdG9tYS16azgxMHRzdC00ay11aGQtc2hvcnQtdGhyb3ctbGFzZXItZ29sZi1zaW11bGF0b3ItcHJvamVjdG9yLXJlYmFsYW5jZWQtMS5qcGcifSx7ImIiOiJPcHRvbWEiLCJtIjoiR1QyNDAwSERSIiwidHIiOlswLjQ5NiwwLjQ5Nl0sInIiOiIxMDgwcCIsImwiOjQyMDAsInMiOiJMYXNlciIsImEiOiIxNjo5Iiwic2EiOlsiMTY6OSIsIjQ6MyIsIjE2OjEwIl0sInAiOjEyOTksImgiOiJvcHRvbWEtZ3QyNDAwaGRyLXNob3J0LXRocm93LWdvbGYtc2ltdWxhdG9yLXByb2plY3RvciIsImkiOiJmaWxlcy9ndDI0MDBoZHItcmVhci12aWV3LmpwZyJ9XQ==");
var _d=JSON.parse(_0x).filter(function(p){return p.m!=="ZK430ST";});

/* ---- Constants ---- */
var REAR_LM_CLEARANCE=7;/* ft behind tee for radar launch monitors */
var SIDE_MARGIN=0.5;/* ft each side of screen */
var CEIL_MARGIN=1;/* ft from ceiling */
var FLOOR_MARGIN=0.5;/* ft from floor */
var STORE="https://topshelfgolf.com/products/";
var IMGCDN="https://cdn.shopify.com/s/files/1/0041/6386/2626/";
function projImg(p,width,cls){
  /* Shopify CDN resizes via ?width=; 2x srcset for retina */
  if(!p.i)return "";
  var u=IMGCDN+p.i;
  return '<img class="'+cls+'" src="'+u+'?width='+(width*2)+'" srcset="'+u+'?width='+width+' 1x, '+u+'?width='+(width*2)+' 2x" alt="'+esc(p.b+" "+p.m)+' golf simulator projector" loading="lazy" width="'+width+'" decoding="async">';
}

/* ---- State ---- */
var state={
  roomW:12, roomD:15, roomH:9,
  teeDistance:8, lmPlacement:"side", ambient:"some",
  ratio:"16:9",
  screenW:10, swPinned:false, screenGain:1, budget:0,
  filterRes:"all", filterBrand:"all", filterLight:"all"
};

/* ---- Helpers ---- */
function $(id){return document.getElementById(id);}
function qs(sel){return document.querySelector(sel);}
function qsa(sel){return document.querySelectorAll(sel);}

function esc(s){
  return String(s==null?"":s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#39;");
}

function clamp(n,lo,hi){return Math.min(hi,Math.max(lo,n));}

function aspectH(w,ratio){
  var parts=ratio.split(":").map(Number);
  return w*(parts[1]/parts[0]);
}


function calcDiag(w,h){
  return Math.sqrt(w*w+h*h)*12;/* inches */
}

function maxScreenW(roomW){
  return roomW-2*SIDE_MARGIN;
}

function maxScreenH(roomH){
  return roomH-CEIL_MARGIN-FLOOR_MARGIN;
}

function optimalScreenW(roomW,roomH,ratio){
  var mw=maxScreenW(roomW);
  var mh=maxScreenH(roomH);
  var hForW=aspectH(mw,ratio);
  if(hForW>mh){
    var parts=ratio.split(":").map(Number);
    mw=mh*(parts[0]/parts[1]);
  }
  return Math.floor(mw*4)/4;
}

function aspectNumber(ratio){
  var parts=ratio.split(":").map(Number);
  return parts[0]/parts[1];
}

function imageGeometry(proj,screenW,screenH){
  /* Projected image must cover BOTH screen dimensions at the projector's
     native aspect; whichever dimension binds, the other overspills. */
  var ar=aspectNumber(proj.a);
  var imageW=Math.max(screenW,screenH*ar);
  var imageH=imageW/ar;
  return {
    imageW:imageW,
    imageH:imageH,
    overspill:Math.max(0,(imageW-screenW)/2),
    vOverspill:Math.max(0,(imageH-screenH)/2)
  };
}

function throwDist(tr,imageW){
  return tr*imageW;
}

function availableDepth(roomD){
  var rear=state.lmPlacement==="rear"?REAR_LM_CLEARANCE:0;
  /* Projector mounts between screen and tee; keep 1 ft clear of the hitting zone. */
  return Math.max(0,Math.min(state.teeDistance-1,roomD-rear-1));
}

function fitScore(minTD,maxTD,avail){
  /* Score the usable wide-end mount; zoom range is flexibility, not a penalty. */
  if(minTD>avail) return 0;
  var margin=avail-minTD;
  if(margin>=2) return 3;
  if(margin>=0.75) return 2;
  return 1;
}

function fmtPrice(p){
  return "$"+p.toLocaleString("en-US");
}

function fmtDist(d){
  var ft=Math.floor(d);
  var inches=Math.round((d-ft)*12);
  if(inches===12){ft++;inches=0;}
  return ft+"' "+inches+'"';
}

function calcFootLamberts(lumens,imageW,imageH,gain){
  /* Light spreads over the full PROJECTED image; when the image overspills
     a tall screen, the lumens that miss the screen don't brighten it. */
  var imageAreaSqFt=imageW*imageH;
  if(!(imageAreaSqFt>0))return 0;
  return lumens*(gain||1)/imageAreaSqFt;
}

function brightnessRating(fl){
  var target=state.ambient==="bright"?80:state.ambient==="some"?50:24;
  var ratio=fl/target;
  if(ratio>=1.15) return {label:"Bright",cls:"tsg-bright-excellent",tip:"Exceeds the target for your selected lighting",score:3};
  if(ratio>=0.85) return {label:"On Target",cls:"tsg-bright-good",tip:"Near the target for your selected lighting",score:2};
  if(ratio>=0.6) return {label:"Borderline",cls:"tsg-bright-ok",tip:"May require dimmer lighting or a smaller screen",score:1};
  return {label:"Underpowered",cls:"tsg-bright-dim",tip:"Not recommended for your selected lighting",score:0};
}

function budgetScore(price){
  /* "Up to $X" is a hard limit — never recommend above the stated budget. */
  if(!state.budget)return 2;
  return price<=state.budget?2:0;
}

function projectorResult(proj,w,screenH,avail){
  var geo=imageGeometry(proj,w,screenH);
  var minTD=throwDist(proj.tr[0],geo.imageW);
  var maxTD=throwDist(proj.tr[1],geo.imageW);
  var score=fitScore(minTD,maxTD,avail);
  var fl=calcFootLamberts(proj.l,geo.imageW,geo.imageH,state.screenGain);
  var bright=brightnessRating(fl);
  var budget=budgetScore(proj.p);
  var saOK=proj.sa.indexOf(state.ratio)!==-1;
  var rank=score*100+bright.score*25+budget*15+(proj.r==="4K"?8:0)-proj.p/100000;
  return {proj:proj,score:score,minTD:minTD,maxTD:maxTD,mountMax:Math.min(maxTD,avail),geo:geo,fl:fl,bright:bright,budget:budget,saOK:saOK,rank:rank};
}

/* ---- Lightweight SVG diagrams ---- */
var SVG_NS="http://www.w3.org/2000/svg";
function svgEl(tag,attrs,text){
  var el=document.createElementNS(SVG_NS,tag);
  Object.keys(attrs||{}).forEach(function(k){el.setAttribute(k,attrs[k]);});
  if(text)el.textContent=text;
  return el;
}
function buildRoomSVG(){
  var svg=svgEl("svg",{viewBox:"0 0 400 500","aria-label":"Top-down room layout diagram"});
  [
    ["rect",{id:"tsg-svg-room",x:50,y:50,width:300,height:380,fill:"#f0f2f5",stroke:"#c0c5d0",rx:4}],
    ["rect",{id:"tsg-svg-screen",x:100,y:54,width:200,height:8,fill:"#a3cd3a",rx:2}],
    ["text",{id:"tsg-svg-screen-label",x:200,y:48,"text-anchor":"middle",fill:"#5a8e1f"},"Impact Screen"],
    ["ellipse",{id:"tsg-svg-golfer",cx:200,cy:300,rx:20,ry:20,fill:"none",stroke:"#f59729"}],
    ["text",{id:"tsg-svg-golfer-label",x:200,y:304,"text-anchor":"middle",fill:"#f59729"},"Golfer"],
    ["path",{id:"tsg-svg-swing-l",fill:"none",stroke:"#f59729"}],["path",{id:"tsg-svg-swing-r",fill:"none",stroke:"#f59729"}],
    ["text",{id:"tsg-svg-swing-l-label","text-anchor":"end",fill:"#f59729"}],["text",{id:"tsg-svg-swing-r-label",fill:"#f59729"}],
    ["rect",{id:"tsg-svg-projzone",x:160,y:150,width:80,height:40,fill:"#eef5df",stroke:"#a3cd3a",rx:4}],
    ["text",{id:"tsg-svg-proj-label",x:200,y:175,"text-anchor":"middle",fill:"#5a8e1f"},"Projector Zone"],
    ["line",{id:"tsg-svg-throw-line",stroke:"#a3cd3a"}],["line",{id:"tsg-svg-width-arrow",stroke:"#9ca3af"}],
    ["text",{id:"tsg-svg-width-dim","text-anchor":"middle",fill:"#6b7280"}],["line",{id:"tsg-svg-depth-arrow",stroke:"#9ca3af"}],
    ["text",{id:"tsg-svg-depth-dim","text-anchor":"middle",fill:"#6b7280"}],["text",{id:"tsg-svg-golfer-dist","text-anchor":"middle",fill:"#f59729"}]
  ].forEach(function(n){svg.appendChild(svgEl(n[0],n[1],n[2]));});
  $("tsg-room-diagram-container").appendChild(svg);
}
function buildSideSVG(){
  var svg=svgEl("svg",{viewBox:"0 0 500 300","aria-label":"Side-view room layout showing projector placement"});
  [
    ["rect",{x:40,y:30,width:420,height:240,fill:"#f0f2f5",stroke:"#c0c5d0",rx:4}],
    ["rect",{id:"tsg-side-screen",x:45,y:50,width:6,height:180,fill:"#a3cd3a"}],
    ["rect",{id:"tsg-side-projector",x:180,y:33,width:20,height:12,fill:"#f59729",rx:2}],
    ["text",{id:"tsg-side-proj-label",x:190,y:56,"text-anchor":"middle",fill:"#f59729"},"Projector"],
    ["polygon",{id:"tsg-side-cone",fill:"#eef5df",stroke:"#a3cd3a"}],
    ["g",{id:"tsg-side-golfer"}],["text",{id:"tsg-side-golfer-label","text-anchor":"middle",fill:"#f59729"}],
    ["line",{id:"tsg-side-throw",x1:51,y1:282,stroke:"#a3cd3a"}],["text",{id:"tsg-side-throw-label",y:296,"text-anchor":"middle",fill:"#5a8e1f"}],
    ["text",{id:"tsg-side-ceil-label",x:470,y:155,"text-anchor":"middle",fill:"#6b7280"}],
    ["text",{id:"tsg-side-depth-label",x:250,y:14,"text-anchor":"middle",fill:"#6b7280"}]
  ].forEach(function(n){svg.appendChild(svgEl(n[0],n[1],n[2]));});
  $("tsg-side-diagram-container").appendChild(svg);
}

/* ---- Sync Sliders ↔ Inputs ---- */
function syncPair(sliderId,inputId,key){
  var slider=$(sliderId);
  var input=$(inputId);
  slider.addEventListener("input",function(){
    input.value=slider.value;
    state[key]=parseFloat(slider.value);
    onInputChange();
  });
  input.addEventListener("change",function(){
    var v=parseFloat(input.value);
    if(isNaN(v))return;
    v=Math.max(parseFloat(slider.min),Math.min(parseFloat(slider.max),v));
    input.value=v;
    slider.value=v;
    state[key]=v;
    onInputChange();
  });
}

/* ---- Update Room Diagram (fully proportional) ---- */
function updateRoomDiagram(){
  var pad=50, maxW=300, maxH=380;
  var scaleW=maxW/state.roomW, scaleH=maxH/state.roomD;
  var scale=Math.min(scaleW,scaleH);
  var rW=state.roomW*scale, rH=state.roomD*scale;
  var rX=pad+(maxW-rW)/2, rY=pad+(maxH-rH)/2;
  var cx=rX+rW/2;

  /* Room rectangle */
  $("tsg-svg-room").setAttribute("x",rX);
  $("tsg-svg-room").setAttribute("y",rY);
  $("tsg-svg-room").setAttribute("width",rW);
  $("tsg-svg-room").setAttribute("height",rH);

  /* Screen (proportional to room width) */
  var optSW=optimalScreenW(state.roomW,state.roomH,state.ratio);
  var screenPx=optSW*scale;
  $("tsg-svg-screen").setAttribute("x",cx-screenPx/2);
  $("tsg-svg-screen").setAttribute("y",rY+4);
  $("tsg-svg-screen").setAttribute("width",screenPx);
  $("tsg-svg-screen-label").setAttribute("x",cx);
  $("tsg-svg-screen-label").setAttribute("y",rY-4);

  /* Golfer position */
  var golferY=rY+state.teeDistance*scale;
  $("tsg-svg-golfer").setAttribute("cx",cx);
  $("tsg-svg-golfer").setAttribute("cy",golferY);
  $("tsg-svg-golfer-label").setAttribute("x",cx);
  $("tsg-svg-golfer-label").setAttribute("y",golferY+4);

  /* Swing arc (~4ft radius scaled) */
  var swingR=Math.min(4*scale,(rW/2)-10);
  var sArcL="M"+(cx-swingR)+","+golferY+" A"+swingR+","+swingR+" 0 0,1 "+cx+","+(golferY-swingR);
  var sArcR="M"+cx+","+(golferY-swingR)+" A"+swingR+","+swingR+" 0 0,1 "+(cx+swingR)+","+golferY;
  $("tsg-svg-swing-l").setAttribute("d",sArcL);
  $("tsg-svg-swing-r").setAttribute("d",sArcR);

  /* Swing clearance labels */
  var clearance=((state.roomW/2)-0.5).toFixed(1);
  $("tsg-svg-swing-l-label").setAttribute("x",rX+8);
  $("tsg-svg-swing-l-label").setAttribute("y",golferY-5);
  $("tsg-svg-swing-l-label").textContent=clearance+" ft";
  $("tsg-svg-swing-r-label").setAttribute("x",rX+rW-8);
  $("tsg-svg-swing-r-label").setAttribute("y",golferY-5);
  $("tsg-svg-swing-r-label").textContent=clearance+" ft";

  /* Projector zone (between screen and golfer) */
  var midThrow=optSW*0.6;
  var projPxFromScreen=Math.min(midThrow*scale,state.teeDistance*scale*0.7);
  var projZoneY=rY+projPxFromScreen-20;
  var projZoneH=Math.max(30,state.teeDistance*scale*0.25);
  $("tsg-svg-projzone").setAttribute("x",cx-40);
  $("tsg-svg-projzone").setAttribute("y",projZoneY);
  $("tsg-svg-projzone").setAttribute("height",projZoneH);
  $("tsg-svg-proj-label").setAttribute("x",cx);
  $("tsg-svg-proj-label").setAttribute("y",projZoneY+projZoneH/2+3);

  /* Throw distance line */
  $("tsg-svg-throw-line").setAttribute("x1",cx);
  $("tsg-svg-throw-line").setAttribute("y1",rY+12);
  $("tsg-svg-throw-line").setAttribute("x2",cx);
  $("tsg-svg-throw-line").setAttribute("y2",projZoneY);

  /* Width dimension arrow + label */
  $("tsg-svg-width-arrow").setAttribute("x1",rX);
  $("tsg-svg-width-arrow").setAttribute("x2",rX+rW);
  $("tsg-svg-width-arrow").setAttribute("y1",rY+rH+18);
  $("tsg-svg-width-arrow").setAttribute("y2",rY+rH+18);
  $("tsg-svg-width-dim").setAttribute("x",cx);
  $("tsg-svg-width-dim").setAttribute("y",rY+rH+34);
  $("tsg-svg-width-dim").textContent=state.roomW+" ft";

  /* Depth dimension arrow + label */
  var depthArrowX=rX-30;
  $("tsg-svg-depth-arrow").setAttribute("x1",depthArrowX);
  $("tsg-svg-depth-arrow").setAttribute("x2",depthArrowX);
  $("tsg-svg-depth-arrow").setAttribute("y1",rY);
  $("tsg-svg-depth-arrow").setAttribute("y2",rY+rH);
  $("tsg-svg-depth-dim").setAttribute("x",depthArrowX);
  var depthMid=rY+rH/2;
  $("tsg-svg-depth-dim").setAttribute("y",depthMid);
  $("tsg-svg-depth-dim").setAttribute("transform","rotate(-90,"+depthArrowX+","+depthMid+")");
  $("tsg-svg-depth-dim").textContent=state.roomD+" ft";

  /* Golfer-to-screen distance label */
  $("tsg-svg-golfer-dist").setAttribute("x",rX+rW+18);
  var gDistMid=(rY+golferY)/2;
  $("tsg-svg-golfer-dist").setAttribute("y",gDistMid);
  $("tsg-svg-golfer-dist").setAttribute("transform","rotate(90,"+(rX+rW+18)+","+gDistMid+")");
  $("tsg-svg-golfer-dist").textContent=state.teeDistance+" ft to screen";
}

/* ---- Update Screen Info ---- */
function updateScreenInfo(){
  var optW=optimalScreenW(state.roomW,state.roomH,state.ratio);
  var optH=aspectH(optW,state.ratio);
  var optDiag=calcDiag(optW,optH);

  var optSize=$("tsg-optimal-size"),optDiagEl=$("tsg-optimal-diag");
  if(optSize)optSize.textContent=optW+" × "+optH.toFixed(1)+" ft";
  if(optDiagEl)optDiagEl.textContent=Math.round(optDiag)+'" diagonal';

  var roomSummary=$("tsg-room-summary");
  if(roomSummary)roomSummary.textContent=state.roomW+" × "+state.roomD+" ft room with "+state.roomH+" ft ceilings";
  var maxW=optimalScreenW(state.roomW,state.roomH,state.ratio);
  $("tsg-screen-width-slider").max=maxW;
  $("tsg-screen-width").max=maxW;

  /* Keep a width the user (or a shared link) chose; only clamp it to the
     new maximum. Otherwise default to the recommended optimal width. */
  if(state.swPinned&&Number.isFinite(state.screenW)&&state.screenW>=4){
    state.screenW=Math.min(state.screenW,maxW);
  } else {
    state.screenW=optW;
  }
  $("tsg-screen-width-slider").value=state.screenW;
  $("tsg-screen-width").value=state.screenW;

  updateScreenComputed();
}

function updateScreenComputed(){
  var w=state.screenW;
  var h=aspectH(w,state.ratio);
  var diag=calcDiag(w,h);
  $("tsg-screen-height-display").textContent=h.toFixed(1)+" ft";
  $("tsg-screen-diag-display").textContent=Math.round(diag)+'"';
  var validation=[];
  if(w>maxScreenW(state.roomW))validation.push("Screen is wider than the room clearance allows.");
  if(h>maxScreenH(state.roomH))validation.push("Screen is too tall for the available ceiling height.");
  $("tsg-screen-validation").textContent=validation.join(" ");

  /* Update side view diagram */
  updateSideDiagram();
}

function updateSideDiagram(){
  var w=state.screenW;
  var roomDepthPx=400;/* usable horizontal pixels (40 to 460) */
  var ftToPx=roomDepthPx/state.roomD;

  /* Screen height on diagram */
  var screenH=aspectH(w,state.ratio);
  var ceilPx=240;/* vertical room pixels (30 to 270) */
  var screenPx=Math.min(ceilPx-20,(screenH/state.roomH)*ceilPx);
  var screenY=270-screenPx-10;
  $("tsg-side-screen").setAttribute("y",screenY);
  $("tsg-side-screen").setAttribute("height",screenPx);

  /* Golfer position */
  var golferX=40+state.teeDistance*ftToPx;
  $("tsg-side-golfer").setAttribute("transform","translate("+golferX+",170)");
  $("tsg-side-golfer-label").setAttribute("x",golferX);
  $("tsg-side-golfer-label").textContent="Golfer ("+state.teeDistance+" ft)";

  /* Projector position (ceiling-mounted, midway between screen and golfer) */
  var midTD=w*0.6;
  var projX=40+Math.min(midTD,state.teeDistance-1)*ftToPx;
  $("tsg-side-projector").setAttribute("x",projX-10);
  $("tsg-side-proj-label").setAttribute("x",projX);

  /* Light cone (from ceiling projector to screen) */
  var coneStr=projX+",45 48,"+screenY+" 48,"+(screenY+screenPx);
  $("tsg-side-cone").setAttribute("points",coneStr);

  /* Throw distance arrow + label */
  $("tsg-side-throw").setAttribute("x2",projX);
  $("tsg-side-throw-label").setAttribute("x",(51+projX)/2);
  $("tsg-side-throw-label").textContent="Throw: ~"+midTD.toFixed(1)+" ft";

  /* Ceiling height label */
  $("tsg-side-ceil-label").textContent=state.roomH+" ft";

  /* Room depth label */
  $("tsg-side-depth-label").textContent=state.roomD+" ft deep";
}

/* ---- Render Results ---- */
var expandedCards={};
function renderResults(){
  var grid=$("tsg-results-grid");
  grid.innerHTML="";
  var w=state.screenW, screenH=aspectH(w,state.ratio);
  var avail=availableDepth(state.roomD);
  $("tsg-result-summary").textContent=w+" ft wide screen, "+state.teeDistance+" ft tee distance, "+state.ambient+" ambient light ("+state.ratio+")";

  /* Room warnings */
  var warnings=[];
  if(avail<2) warnings.push("Your room may be too shallow for a golf simulator. Most projectors need at least 2 ft of throw distance.");
  if(state.roomW<10) warnings.push("Room width under 10 ft may limit swing clearance. Consider a wider space for comfortable play.");
  if(state.roomH<8) warnings.push("Ceiling height under 8 ft may restrict your golf swing. Most golfers need 8.5–9 ft minimum.");
  if(state.lmPlacement==="rear"&&state.roomD<state.teeDistance+REAR_LM_CLEARANCE) warnings.push("This room is too shallow for the selected tee distance plus a rear-mounted launch monitor's 7 ft clearance.");
  if(state.lmPlacement==="rear"&&avail<2) warnings.push("A rear-mounted launch monitor leaves too little projector depth. Consider a side or overhead launch monitor.");
  if(w>maxScreenW(state.roomW)||screenH>maxScreenH(state.roomH)) warnings.push("The selected screen does not fit within the room clearances.");
  var warnEl=$("tsg-room-warnings");
  if(warnings.length>0){
    warnEl.innerHTML=warnings.map(function(w){return '<div class="tsg-warning-item">&#x26A0; '+w+'</div>';}).join("");
    warnEl.style.display="block";
  } else {
    warnEl.style.display="none";
  }

  var results=[];
  _d.forEach(function(proj){
    var result=projectorResult(proj,w,screenH,avail);
    if(state.filterRes!=="all"&&proj.r!==state.filterRes)return;
    if(state.filterBrand!=="all"&&proj.b!==state.filterBrand)return;
    if(state.filterLight!=="all"&&proj.s!==state.filterLight)return;
    if(result.score>0&&result.budget>0&&result.saOK)results.push(result);
  });
  results.sort(function(a,b){return b.rank-a.rank;});

  $("tsg-result-count").textContent="("+results.length+")";
  if(results.length===0){
    $("tsg-no-results").style.display="block";
    renderQuickPicks([]);
    return;
  }
  $("tsg-no-results").style.display="none";
  renderQuickPicks(results);

  results.forEach(function(r){
    var p=r.proj;
    var fitClass=r.score===3?"tsg-perfect-fit":r.score===2?"tsg-good-fit":"tsg-tight-fit";
    var fitLabel=r.score===3?"Perfect Fit":r.score===2?"Good Fit":"Tight Fit";
    var fitCss=r.score===3?"tsg-fit-perfect":r.score===2?"tsg-fit-good":"tsg-fit-tight";

    var throwText;
    if(p.tr[0]===p.tr[1]){
      throwText="Mount "+r.minTD.toFixed(1)+" ft from screen";
    } else {
      throwText="Mount "+r.minTD.toFixed(1)+" – "+r.mountMax.toFixed(1)+" ft from screen";
    }

    var trRange=p.tr[0]===p.tr[1]?p.tr[0].toString():p.tr[0]+"–"+p.tr[1];
    var depthPct=Math.round((r.minTD/avail)*100);
    var screenDiag=Math.round(calcDiag(w,screenH));
    var fl=r.fl, br=r.bright;
    var spillText;
    if(r.geo.overspill>0.05){
      spillText="Fills screen height with "+r.geo.overspill.toFixed(1)+" ft horizontal overspill per side.";
    } else if(r.geo.vOverspill>0.05){
      spillText="Fills screen width with "+r.geo.vOverspill.toFixed(1)+" ft vertical overspill above and below.";
    } else {
      spillText="Native image fits the screen.";
    }
    var why=(r.score===3?"Comfortable mounting clearance. ":"Fits with limited mounting clearance. ")+(br.score>=2?"Brightness suits your selected room. ":"Plan to control light or use a smaller screen. ")+spillText;

    var card=document.createElement("div");
    card.className="tsg-proj-card "+fitClass+(expandedCards[p.h]?" tsg-expanded":"");
    card.setAttribute("tabindex","0");
    card.setAttribute("role","button");
    card.setAttribute("aria-expanded",expandedCards[p.h]?"true":"false");
    card.innerHTML=
      '<div class="tsg-proj-media">'+
        (projImg(p,96,"tsg-proj-img")||'<span class="tsg-proj-brand">'+p.b+'</span>')+
        '<span class="tsg-proj-fit-badge '+fitCss+'">'+fitLabel+'</span>'+
      '</div>'+
      '<div class="tsg-proj-info">'+
        '<div class="tsg-proj-name">'+p.b+" "+p.m+'</div>'+
        '<div class="tsg-proj-specs">'+
          '<span class="tsg-proj-spec"><strong>'+p.r+'</strong></span>'+
          '<span class="tsg-proj-spec"><strong>'+p.l.toLocaleString()+'</strong> lumens</span>'+
          '<span class="tsg-proj-spec">'+p.s+'</span>'+
          '<span class="tsg-proj-spec tsg-proj-spec--ratios" title="Supported aspect ratios">'+p.sa.join(" &middot; ")+'</span>'+
          '<span class="tsg-proj-spec '+br.cls+'" title="'+br.tip+'">&#x2600; '+br.label+'</span>'+
        '</div>'+
        '<div class="tsg-proj-throw">&#x1F4CD; '+throwText+'</div>'+
        '<div class="tsg-proj-why">'+why+'</div>'+
      '</div>'+
      '<div class="tsg-proj-action">'+
        '<div class="tsg-proj-price">'+fmtPrice(p.p)+'</div>'+
      '</div>'+
      '<div class="tsg-proj-detail">'+
        '<div class="tsg-proj-detail-grid">'+
          '<div class="tsg-proj-detail-item"><div class="tsg-proj-detail-label">Resolution</div><div class="tsg-proj-detail-val">'+p.r+'</div></div>'+
          '<div class="tsg-proj-detail-item"><div class="tsg-proj-detail-label">Brightness</div><div class="tsg-proj-detail-val">'+p.l.toLocaleString()+' lumens ('+Math.round(fl)+' fL)</div></div>'+
          '<div class="tsg-proj-detail-item"><div class="tsg-proj-detail-label">Screen Brightness</div><div class="tsg-proj-detail-val"><span class="'+br.cls+'">'+br.label+'</span> — '+br.tip+'</div></div>'+
          '<div class="tsg-proj-detail-item"><div class="tsg-proj-detail-label">Light Source</div><div class="tsg-proj-detail-val">'+p.s+'</div></div>'+
          '<div class="tsg-proj-detail-item"><div class="tsg-proj-detail-label">Aspect Ratios</div><div class="tsg-proj-detail-val">'+p.a+' native'+(function(){var o=p.sa.filter(function(x){return x!==p.a;});return o.length?", supports "+o.join(", "):"";})()+'</div></div>'+
          '<div class="tsg-proj-detail-item"><div class="tsg-proj-detail-label">Throw Ratio</div><div class="tsg-proj-detail-val">'+trRange+'</div></div>'+
          '<div class="tsg-proj-detail-item"><div class="tsg-proj-detail-label">Usable Mounting Range</div><div class="tsg-proj-detail-val">'+r.minTD.toFixed(1)+(r.minTD!==r.mountMax?" – "+r.mountMax.toFixed(1):"")+' ft, measured to lens</div></div>'+
          '<div class="tsg-proj-detail-item"><div class="tsg-proj-detail-label">Room Depth Used</div><div class="tsg-proj-detail-val">'+depthPct+'% of '+avail.toFixed(1)+' ft available</div></div>'+
          '<div class="tsg-proj-detail-item"><div class="tsg-proj-detail-label">Image on Your Screen</div><div class="tsg-proj-detail-val">'+w+' \u00d7 '+screenH.toFixed(1)+' ft ('+screenDiag+'\u2033)</div></div>'+
          '<div class="tsg-proj-detail-item"><div class="tsg-proj-detail-label">Projected Image</div><div class="tsg-proj-detail-val">'+r.geo.imageW.toFixed(1)+' \u00d7 '+r.geo.imageH.toFixed(1)+' ft'+(r.geo.overspill>0.05?" ("+r.geo.overspill.toFixed(1)+" ft side overspill)":r.geo.vOverspill>0.05?" ("+r.geo.vOverspill.toFixed(1)+" ft top/bottom overspill)":"")+'</div></div>'+
          '<div class="tsg-proj-detail-item"><div class="tsg-proj-detail-label">'+esc(state.ratio)+' Screen Support</div><div class="tsg-proj-detail-val">'+(r.saOK?"Listed native mode":"Custom setup required")+'</div></div>'+
        '</div>'+
        '<a href="'+STORE+p.h+'" class="tsg-proj-view-page" target="_blank" rel="noopener">View Product Page \u2192</a>'+
      '</div>';

    card.addEventListener("click",function(e){
      if(e.target.closest(".tsg-proj-view-page")) return;
      card.classList.toggle("tsg-expanded");
      var open=card.classList.contains("tsg-expanded");
      card.setAttribute("aria-expanded",open?"true":"false");
      /* survive live re-renders */
      if(open)expandedCards[p.h]=true;else delete expandedCards[p.h];
    });
    card.addEventListener("keydown",function(e){
      /* Only toggle when the card itself is focused — Enter on the product
         link (or any interactive descendant) must keep its native action. */
      if(e.target!==card)return;
      if(e.key==="Enter"||e.key===" "){e.preventDefault();card.click();}
    });

    grid.appendChild(card);
  });

  /* Add "tap to see details" hint on first card */
  var firstCard=grid.querySelector(".tsg-proj-card");
  if(firstCard && !firstCard.querySelector(".tsg-tap-hint")){
    var hint=document.createElement("div");
    hint.className="tsg-tap-hint";
    hint.textContent="\u25BC Tap any projector to see full details";
    firstCard.appendChild(hint);
  }
}

function renderQuickPicks(results){
  var wrap=$("tsg-quick-picks");
  if(!wrap)return;
  if(!results.length){wrap.innerHTML="";return;}
  var best=results[0];
  var value=results.slice().sort(function(a,b){return (b.rank/b.proj.p)-(a.rank/a.proj.p);})[0];
  var bright=results.slice().sort(function(a,b){return b.fl-a.fl;})[0];
  var picks=[["Best Overall",best,"Best balance of fit, brightness, resolution, and budget."],["Best Value",value,"Strongest recommendation score per dollar."],["Bright Room Pick",bright,"Highest estimated screen brightness among your matches."]];
  var seen={};
  wrap.innerHTML=picks.filter(function(x){if(seen[x[1].proj.h])return false;seen[x[1].proj.h]=1;return true;}).map(function(x){
    return '<a class="tsg-quick-pick" href="'+STORE+x[1].proj.h+'" target="_blank" rel="noopener"><div class="tsg-quick-pick__label">'+x[0]+'</div><div class="tsg-quick-pick__name">'+esc(x[1].proj.b+' '+x[1].proj.m)+'</div><div class="tsg-quick-pick__why">'+x[2]+'</div><span class="tsg-quick-pick__cta">View Product Page \u2192</span></a>';
  }).join("");
}


/* ---- Input Change Handler ---- */
function constrainTee(){
  /* The tee must sit inside the room with 1 ft to the rear wall. */
  var maxTee=state.roomD-1;
  if(state.teeDistance>maxTee){
    state.teeDistance=maxTee;
    var input=$("tsg-tee-distance"),slider=$("tsg-tee-distance-slider");
    if(input)input.value=maxTee;
    if(slider)slider.value=maxTee;
  }
}

/* Live single-page pipeline: every control change re-renders the results.
   Diagrams/labels update immediately (cheap attribute writes); the card
   grid re-render is debounced so slider drags stay smooth. */
var renderTimer=null;
function scheduleRender(){
  clearTimeout(renderTimer);
  renderTimer=setTimeout(renderResults,120);
}
function onInputChange(){
  constrainTee();
  updateScreenInfo();
  updateRoomDiagram();
  scheduleRender();
}

function setChoice(name,key){
  qsa('input[name="'+name+'"]').forEach(function(input){
    input.addEventListener("change",function(){state[key]=input.value;onInputChange();});
  });
}

function buildShareUrl(){
  var u=new URL(window.location.href);
  ["rw","rd","rh","tee","lm","light","ratio","sw","gain","budget"].forEach(function(k){u.searchParams.delete(k);});
  u.searchParams.set("rw",state.roomW);u.searchParams.set("rd",state.roomD);u.searchParams.set("rh",state.roomH);
  u.searchParams.set("tee",state.teeDistance);u.searchParams.set("lm",state.lmPlacement);u.searchParams.set("light",state.ambient);
  u.searchParams.set("ratio",state.ratio);u.searchParams.set("sw",state.screenW);u.searchParams.set("gain",state.screenGain);u.searchParams.set("budget",state.budget);
  return u.toString();
}

var RATIOS=["16:9","16:10","4:3","1:1"];
var LM_PLACEMENTS=["side","rear"];
var AMBIENTS=["dark","some","bright"];
var BUDGETS=[0,1500,2500,5000,8000,16000];

function loadSharedState(){
  var q=new URLSearchParams(window.location.search);
  function number(key,fallback,lo,hi){
    if(!q.has(key))return fallback;
    var n=parseFloat(q.get(key));
    return Number.isFinite(n)?clamp(n,lo,hi):fallback;
  }
  function pick(key,allowed,fallback){
    var v=q.get(key);
    return allowed.indexOf(v)!==-1?v:fallback;
  }
  /* Bounds mirror the page's slider min/max attributes. */
  state.roomW=number("rw",state.roomW,8,25);
  state.roomD=number("rd",state.roomD,10,30);
  state.roomH=number("rh",state.roomH,7,14);
  state.teeDistance=number("tee",state.teeDistance,6,14);
  state.screenGain=number("gain",state.screenGain,0.7,1.3);
  var b=number("budget",state.budget,0,16000);
  state.budget=BUDGETS.indexOf(b)!==-1?b:state.budget;
  state.lmPlacement=pick("lm",LM_PLACEMENTS,state.lmPlacement);
  state.ambient=pick("light",AMBIENTS,state.ambient);
  state.ratio=pick("ratio",RATIOS,state.ratio);
  /* Tee must be inside the room with margin to the rear wall. */
  state.teeDistance=Math.min(state.teeDistance,state.roomD-1);
  if(q.has("sw")){
    var sw=parseFloat(q.get("sw"));
    if(Number.isFinite(sw)){
      state.screenW=clamp(sw,4,optimalScreenW(state.roomW,state.roomH,state.ratio));
      state.swPinned=true;
    }
  }
}

function applyStateToControls(){
  [["tsg-room-width",state.roomW],["tsg-room-depth",state.roomD],["tsg-room-height",state.roomH],["tsg-tee-distance",state.teeDistance],["tsg-screen-width",state.screenW],["tsg-screen-gain",state.screenGain]].forEach(function(x){
    var input=$(x[0]),slider=$(x[0]+"-slider");if(input)input.value=x[1];if(slider)slider.value=x[1];
  });
  $("tsg-budget").value=String(state.budget);
  qsa('input[name="lm-placement"]').forEach(function(x){x.checked=x.value===state.lmPlacement;});
  qsa('input[name="ambient"]').forEach(function(x){x.checked=x.value===state.ambient;});
  qsa('.tsg-btn-toggle[data-ratio]').forEach(function(x){var on=x.getAttribute("data-ratio")===state.ratio;x.classList.toggle("active",on);x.setAttribute("aria-pressed",on?"true":"false");});
}

function sharePlan(){
  var url=buildShareUrl(), status=$("tsg-share-status");
  var btn=document.querySelector('.tsg-share-row [data-share-action="copy"]');
  if(navigator.clipboard&&navigator.clipboard.writeText){
    navigator.clipboard.writeText(url).then(function(){
      if(status)status.textContent="Link copied.";
      if(btn){btn.setAttribute("data-share-state","copied");setTimeout(function(){btn.removeAttribute("data-share-state");},2000);}
    },function(){if(status)status.textContent=url;});
  }else if(status)status.textContent=url;
}

function initShareRow(){
  var row=document.querySelector(".tsg-share-row");
  if(!row)return;
  var TITLE="Golf Simulator Projector Calculator | Top Shelf Golf";
  var TEXT="I sized up my golf simulator room — see which projectors fit:";
  var native=row.querySelector('[data-share-action="native"]');
  if(navigator.share&&native)native.hidden=false;
  row.addEventListener("click",function(e){
    var btn=e.target.closest?e.target.closest("[data-share-action]"):null;
    if(!btn)return;
    var url=buildShareUrl(), action=btn.getAttribute("data-share-action");
    if(action==="copy")sharePlan();
    else if(action==="native"&&navigator.share)navigator.share({title:TITLE,text:TEXT,url:url}).catch(function(){});
    else if(action==="email")window.location.href="mailto:?subject="+encodeURIComponent(TITLE)+"&body="+encodeURIComponent(TEXT+" "+url);
    else if(action==="sms")window.location.href="sms:?&body="+encodeURIComponent(TEXT+" "+url);
    else if(action==="x")window.open("https://twitter.com/intent/tweet?text="+encodeURIComponent(TEXT)+"&url="+encodeURIComponent(url),"_blank","noopener");
    else if(action==="facebook")window.open("https://www.facebook.com/sharer/sharer.php?u="+encodeURIComponent(url),"_blank","noopener");
  });
}

/* ---- Reset ---- */
var DEFAULT_STATE={
  roomW:12, roomD:15, roomH:9,
  teeDistance:8, lmPlacement:"side", ambient:"some",
  ratio:"16:9",
  screenW:10, swPinned:false, screenGain:1, budget:0,
  filterRes:"all", filterBrand:"all", filterLight:"all"
};
function resetCalculator(){
  Object.keys(DEFAULT_STATE).forEach(function(k){state[k]=DEFAULT_STATE[k];});
  expandedCards={};
  applyStateToControls();
  qsa(".tsg-btn-filter").forEach(function(b){b.classList.toggle("active",b.getAttribute("data-filter")==="all");});
  onInputChange();
}

/* ---- Init ---- */
function init(){
  loadSharedState();
  buildRoomSVG();
  buildSideSVG();
  applyStateToControls();
  /* Sync sliders */
  syncPair("tsg-room-width-slider","tsg-room-width","roomW");
  syncPair("tsg-room-depth-slider","tsg-room-depth","roomD");
  syncPair("tsg-room-height-slider","tsg-room-height","roomH");
  syncPair("tsg-tee-distance-slider","tsg-tee-distance","teeDistance");
  syncPair("tsg-screen-gain-slider","tsg-screen-gain","screenGain");
  setChoice("lm-placement","lmPlacement");
  setChoice("ambient","ambient");
  $("tsg-budget").addEventListener("change",function(){state.budget=parseFloat(this.value)||0;scheduleRender();});

  /* Screen width slider */
  var swSlider=$("tsg-screen-width-slider");
  var swInput=$("tsg-screen-width");
  swSlider.addEventListener("input",function(){
    swInput.value=swSlider.value;
    state.screenW=parseFloat(swSlider.value);
    state.swPinned=true;
    updateScreenComputed();
    scheduleRender();
  });
  swInput.addEventListener("change",function(){
    var v=parseFloat(swInput.value);
    if(!Number.isFinite(v))return;
    v=Math.max(4,Math.min(optimalScreenW(state.roomW,state.roomH,state.ratio),v));
    swInput.value=v;
    swSlider.value=v;
    state.screenW=v;
    state.swPinned=true;
    updateScreenComputed();
    scheduleRender();
  });

  /* Aspect ratio buttons */
  qsa(".tsg-btn-toggle[data-ratio]").forEach(function(btn){
    btn.addEventListener("click",function(){
      qsa(".tsg-btn-toggle[data-ratio]").forEach(function(b){
        b.classList.remove("active");
        b.setAttribute("aria-pressed","false");
      });
      btn.classList.add("active");
      btn.setAttribute("aria-pressed","true");
      state.ratio=btn.getAttribute("data-ratio");
      updateScreenInfo();
      updateRoomDiagram();
      scheduleRender();
    });
  });

  /* Filter buttons */
  function setupFilter(selector,key){
    qsa(selector+" .tsg-btn-filter").forEach(function(btn){
      btn.addEventListener("click",function(){
        qsa(selector+" .tsg-btn-filter").forEach(function(b){b.classList.remove("active");});
        btn.classList.add("active");
        state[key]=btn.getAttribute("data-filter");
        renderResults();
      });
    });
  }
  setupFilter(".tsg-filter-res","filterRes");
  setupFilter(".tsg-filter-brand","filterBrand");
  setupFilter(".tsg-filter-light","filterLight");

  /* Action buttons */
  $("tsg-btn-restart").addEventListener("click",resetCalculator);
  initShareRow();

  /* Initial render — results are visible immediately, no steps to walk. */
  updateScreenInfo();
  updateRoomDiagram();
  renderResults();
}

/* Run when DOM ready */
if(document.readyState==="loading"){
  document.addEventListener("DOMContentLoaded",init);
} else {
  init();
}

})();
